var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nav'),_c('MainBanner'),_c('IconBanner'),_c('Promotions'),_c('Welcome'),_c('Announcements'),_c('Giftcard'),_c('Reviews'),_c('Products'),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }